import {
  CommentsCard,
  ExperiencesCard,
  InterviewCard,
  ProfileCard,
  OnboardingStepsCard,
} from '../shared';

import JobsListCard from './JobListCard';

import PrimarySecondaryLayout from '@/components/PrimarySecondaryLayout';
import Stack from '@/components/Stack';
import { GetWorkerQuery } from '@/types/graphql';

type Props = {
  worker: GetWorkerQuery['worker'];
  currentAdminIsCustomerAdmin: boolean;
};

const STACK_GAP = 24;

const WorkerCompleted = ({ worker, currentAdminIsCustomerAdmin }: Props) => (
  <PrimarySecondaryLayout>
    <PrimarySecondaryLayout.Primary>
      <Stack vertical gap={STACK_GAP}>
        <JobsListCard
          currentAdminIsCustomerAdmin={currentAdminIsCustomerAdmin}
          workerId={worker.id}
        />
        <ExperiencesCard worker={worker} />
        <OnboardingStepsCard
          currentAdminIsCustomerAdmin={currentAdminIsCustomerAdmin}
          worker={worker}
        />
      </Stack>
    </PrimarySecondaryLayout.Primary>
    <PrimarySecondaryLayout.Secondary>
      <Stack vertical gap={STACK_GAP}>
        <ProfileCard
          currentAdminIsCustomerAdmin={currentAdminIsCustomerAdmin}
          worker={worker}
        />
        <CommentsCard worker={worker} />
        <InterviewCard isWorkerInProgress={false} worker={worker} />
      </Stack>
    </PrimarySecondaryLayout.Secondary>
  </PrimarySecondaryLayout>
);

export default WorkerCompleted;
